import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { GET_SURGE_FILE_DETAILS, GET_SURGE_FILE_DETAILS_SUCCESS, GET_SURGE_FILE_DETAILS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getFileDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const { fileId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/file-uploads/${fileId}/logs`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: GET_SURGE_FILE_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_SURGE_FILE_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_FILE_DETAILS_ERROR, payload: error });
  }
}

export function* watchgetFileDetails() {
  yield takeEvery(GET_SURGE_FILE_DETAILS, getFileDetails);
}

function* getFileDetailsSaga() {
  yield all([fork(watchgetFileDetails)]);
}

export default getFileDetailsSaga;
